module.exports = __webpack_public_path__ + "static/img/fengji.0b81139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fengji.jpg
// module id = Ha1i
// module chunks = 1